import React, { useState } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import AddIcon from '@material-ui/icons/Add';
import ContractsGrid from './ContractsGrid';
import ContractsForm from './ContractsForm';
import FloatingActionButton from 'components/Shared/FloatingActionButton';
import { FormProvider } from 'context/FormContext';
// re-using this component from contacts
import AddContactScreen from 'components/Contacts/AddContactScreen';
import AuthCheck from 'components/Shared/AuthCheck';

const tabs = [
    new Tab({ label: "Assigned", value: "Assigned", scope: "Contracts", action: "read" }),
    new Tab({ label: "Search/Create", value: "addContracts", scope: "Contracts", action: "create" })
]

const Contracts = () => {
    const [activeTab, setActiveTab] = useState("Assigned");

    return (
        <FormProvider>
            <TabbedPage
                tabs={tabs}
                activeTab={activeTab}
                tabSetterFunc={setActiveTab}
            >
                {activeTab === "Assigned" ? <ContractsGrid /> : <AddContactScreen setActiveTab={setActiveTab} FormComponent={ContractsForm} entityName="Contract" />}
                <AuthCheck scope="Contracts" action="create"><FloatingActionButton onClick={() => setActiveTab("addContracts")}><AddIcon /></FloatingActionButton></AuthCheck>
            </TabbedPage>
        </FormProvider>
    )
}

export default Contracts;